import { useCallback, useState } from "react";

export function useElementHeight<T extends HTMLElement>() {
  const [height, setHeight] = useState(0);

  const ref = useCallback((node: T | null) => {
    if (node !== null) {
      setHeight(node.getBoundingClientRect().height);

      const resizeObserver = new ResizeObserver(() => {
        setHeight(node.getBoundingClientRect().height);
      });
      resizeObserver.observe(node);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, []);

  return [ref, height] as const;
}
